import { NavbarModule } from './../navbar/navbar.module';
import { FooterModule } from './../footer/footer.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { AdminLayoutRoutes } from './admin-layout.routing';

import { SideNavComponent } from '../side-nav/side-nav.component'
import { FooterComponent } from '../footer/footer.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { AdminLayoutComponent } from './admin-layout.component'

@NgModule({
  declarations: [
    AdminLayoutComponent,
    SideNavComponent,
    // FooterComponent,
    // NavbarComponent
  ],
  imports: [
    SharedModule,
    FooterModule,
    NavbarModule,
    RouterModule.forChild(AdminLayoutRoutes),
  ],
})

export class AdminLayoutModule {}
